export default class Slick {
    constructor() {
        this.ourPortfolioSlick = null;
        this.pageHeaderSlick = null;
        this.initPageHeaderSlick();
        this.initPortfolioSlick();
    }

    initPortfolioSlick() {
        this.ourPortfolioSlick = jQuery('section.centered-slider .slick-slider')

        if (this.ourPortfolioSlick.length === 0) {
            this.ourPortfolioSlick = null;
            return;
        }

        if (this.ourPortfolioSlick.hasClass('slick-initialized')) {
            this.ourPortfolioSlick.unslick();
        }

        this.ourPortfolioSlick.slick({
            arrows: true,
            autoplay: true,
            autoplaySpeed: 2000,
            centerMode: true,
            centerPadding: '200px',
            infinite: true,
            slidesToShow: 1,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        centerPadding: '100px',
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        centerPadding: '50px',
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        centerPadding: '25px',
                    }
                }
            ]
        });
    }

    initPageHeaderSlick() {
        this.pageHeaderSlick = jQuery('section.page-header .slick-slider')

        if (this.pageHeaderSlick.length === 0) {
            this.pageHeaderSlick = null;
            return;
        }

        if (this.pageHeaderSlick.hasClass('slick-initialized')) {
            this.pageHeaderSlick.unslick();
        }

        this.pageHeaderSlick.slick({
            arrows: true,
            autoplay: true,
            autoplaySpeed: 2000,
            infinite: true,
            slidesToShow: 1,
        });

        this.pageHeaderSlick.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            if (currentSlide === nextSlide) {
                return;
            }
            let currentOffset = parseInt(this.pageHeaderSlick[0].style.getPropertyValue('--background-position-offset'));
            const offset = -25;

            // determine what direction the slide is changing to
            if (Math.abs(nextSlide - currentSlide) == 1) {
                currentOffset = currentOffset + ((nextSlide - currentSlide > 0) ? offset : -offset);
            }
            else {
                currentOffset = currentOffset + ((nextSlide - currentSlide > 0) ? -offset : offset);
            }

            this.pageHeaderSlick[0].style.setProperty('--background-position-offset', Number(currentOffset).toString() + '%');
        });
    }
}

